import { render, staticRenderFns } from "./IconAlert.vue?vue&type=template&id=6a8517af"
import script from "./IconAlert.vue?vue&type=script&lang=js"
export * from "./IconAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports